import type { FieldKey, RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { getFieldDefinition } from '../domain/fields';
import { findTextCleanlinessProblems, type TextCleanlinessProblem } from '../utils/text';
import { finding } from './helpers';

const TEXT_FIELDS: readonly FieldKey[] = ['sequence', 'code', 'name', 'description', 'unit'];
const PROBLEM_LABELS: Readonly<Record<TextCleanlinessProblem, string>> = {
  'leading-or-trailing-space': '前后空格',
  'repeated-space': '连续多余空格',
  'line-break': '多余换行',
  'control-character': '不可见控制字符',
};

export const BQ013: RuleDefinition = {
  id: 'BQ013',
  name: '文本清洁问题',
  description: '检查前后空格、连续空格、换行和不可见控制字符。',
  defaultSeverity: 'info',
  enabled: true,
  applicableFields: TEXT_FIELDS,
  message: '文本中存在可能影响比对或交付质量的清洁问题。',
  suggestion: '请在原文件中清理多余空白、换行或不可见字符，并保留必要的正常分隔。',
  check: ({ detailRows }) =>
    detailRows.flatMap((row) =>
      TEXT_FIELDS.flatMap((field) => {
        const text = getCellText(row, field);
        const problems = findTextCleanlinessProblems(text);
        if (problems.length === 0) return [];
        return [
          finding(row, field, {
            currentValue: text,
            message: `${getFieldDefinition(field).label}存在：${problems.map((problem) => PROBLEM_LABELS[problem]).join('、')}。`,
          }),
        ];
      }),
    ),
};
